var _rect, _rect2, _g, _path, _path2, _path3, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLoanInputData(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 72,
    height: 72,
    viewBox: "0 0 72 72",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.692308,
    y: 0.692308,
    width: 70.6154,
    height: 70.6154,
    rx: 7.30769,
    fill: "#F5F5F5"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 0.692308,
    y: 0.692308,
    width: 70.6154,
    height: 70.6154,
    rx: 7.30769,
    stroke: "#8E8E8E",
    strokeWidth: 1.38462
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_3088_4925)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M38.766 11.7033V13.6988L31.3207 14.203L23.416 13.6988V11.7033C23.416 11.3575 23.6963 11.0771 24.0422 11.0771H38.1399C38.4857 11.0771 38.766 11.3575 38.766 11.7033Z",
    fill: "#7CA1B1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.7679 11.703V13.6988L35.5585 13.8994V11.703C35.5585 11.357 35.2777 11.0771 34.9316 11.0771H38.1411C38.4871 11.0771 38.7679 11.357 38.7679 11.703Z",
    fill: "#678D98"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M47.4318 16.7351V57.0955C47.4318 58.7724 46.0728 60.1314 44.3959 60.1314H17.7869C16.11 60.1314 14.75 58.7724 14.75 57.0955V16.7351C14.75 15.0582 16.11 13.6992 17.7869 13.6992H19.3891L31.0918 14.4709L42.5238 13.6992H44.3959C46.0728 13.6992 47.4318 15.0582 47.4318 16.7351Z",
    fill: "#DA0067"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M47.4318 16.7346V57.0949C47.4318 58.7718 46.0728 60.1308 44.3959 60.1308H42.5234C44.2004 60.1308 45.5593 58.7718 45.5593 57.0949V16.7346C45.5593 13.5927 42.8715 13.6987 42.8715 13.6987H44.3959C46.0728 13.6987 47.4318 15.0577 47.4318 16.7346Z",
    fill: "#A30751"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44.3961 15.2237V53.513C44.3961 54.3554 43.7131 55.0374 42.8717 55.0374H19.3116C18.4691 55.0374 17.7871 54.3554 17.7871 53.513V15.2237C17.7871 14.3822 18.4691 13.6992 19.3116 13.6992H42.8717C43.7131 13.6992 44.3961 14.3822 44.3961 15.2237Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44.396 15.2237V53.513C44.396 54.3554 43.713 55.0374 42.8715 55.0374H40.1816C41.0241 55.0374 41.7061 54.3554 41.7061 53.513V15.2237C41.7061 14.3822 41.0241 13.6992 40.1816 13.6992H42.8715C43.713 13.6992 44.396 14.3822 44.396 15.2237Z",
    fill: "#E0E0E0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.3356 24.2315H22.3075C21.977 24.2315 21.709 23.9635 21.709 23.6329V21.8212C21.709 21.4906 21.977 21.2227 22.3075 21.2227H40.3356C40.6662 21.2227 40.9342 21.4906 40.9342 21.8212V23.6329C40.9342 23.9635 40.6662 24.2315 40.3356 24.2315Z",
    fill: "#7CA1B1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.9865 13.6992V15.1084C35.9865 16.0621 35.2113 16.8384 34.2575 16.8384H27.9249C26.9711 16.8384 26.1958 16.0621 26.1958 15.1084V13.6992H24.6914V15.1084C24.6914 16.8916 26.1417 18.3428 27.9249 18.3428H34.2575C36.0407 18.3428 37.4909 16.8916 37.4909 15.1084V13.6992H35.9865Z",
    fill: "#E0E0E0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.6558 29.9468H22.4612C22.0458 29.9468 21.709 29.61 21.709 29.1946C21.709 28.7792 22.0458 28.4424 22.4612 28.4424H26.6558C27.0712 28.4424 27.408 28.7792 27.408 29.1946C27.408 29.61 27.0712 29.9468 26.6558 29.9468Z",
    fill: "#7CA1B1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.8475 34.9107H22.4612C22.0458 34.9107 21.709 34.5739 21.709 34.1585C21.709 33.743 22.0458 33.4062 22.4612 33.4062H35.8474C36.2629 33.4062 36.5996 33.743 36.5996 34.1585C36.5996 34.5739 36.263 34.9107 35.8475 34.9107Z",
    fill: "#7CA1B1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.5175 39.8745H22.4612C22.0458 39.8745 21.709 39.5377 21.709 39.1223C21.709 38.7069 22.0458 38.3701 22.4612 38.3701H34.5174C34.9329 38.3701 35.2696 38.7069 35.2696 39.1223C35.2696 39.5377 34.933 39.8745 34.5175 39.8745Z",
    fill: "#7CA1B1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.1875 44.8374H22.4612C22.0458 44.8374 21.709 44.5006 21.709 44.0852C21.709 43.6698 22.0458 43.333 22.4612 43.333H33.1875C33.603 43.333 33.9397 43.6698 33.9397 44.0852C33.9397 44.5006 33.603 44.8374 33.1875 44.8374Z",
    fill: "#7CA1B1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.6558 49.8013H22.4612C22.0458 49.8013 21.709 49.4645 21.709 49.0491C21.709 48.6337 22.0458 48.2969 22.4612 48.2969H26.6558C27.0712 48.2969 27.408 48.6337 27.408 49.0491C27.408 49.4645 27.0712 49.8013 26.6558 49.8013Z",
    fill: "#7CA1B1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M62.0073 30.2973L42.2554 25.0048C41.6959 24.8548 41.1209 25.1869 40.971 25.7462L33.3173 54.3106C33.1673 54.87 33.4994 55.445 34.0587 55.5949L53.8106 60.8875C54.3701 61.0374 54.9451 60.7053 55.095 60.146L62.7487 31.5816C62.8987 31.0222 62.5667 30.4472 62.0073 30.2973Z",
    fill: "#CCCCCC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M60.2742 27.2958L52.6204 55.8598C52.4707 56.4188 51.8955 56.7517 51.3366 56.6019L31.5843 51.3093C31.0254 51.1596 30.6927 50.5835 30.8426 50.0244L38.4963 21.4604C38.6463 20.9004 39.2221 20.5688 39.7812 20.7186L59.5334 26.0112C60.0922 26.161 60.4242 26.7358 60.2742 27.2958Z",
    fill: "#F5F5F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M60.2744 27.2953L52.6209 55.86C52.4715 56.4186 51.8958 56.7516 51.3372 56.6022L48.1719 55.7537C48.7305 55.9031 49.3072 55.5712 49.4566 55.0115L57.1101 26.4478C57.2595 25.8911 56.9316 25.3185 56.3779 25.166L59.5332 26.0115C60.0928 26.1609 60.4248 26.7356 60.2744 27.2953Z",
    fill: "#E0E0E0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M53.7465 34.4792L40.5618 30.9464C40.2587 30.8651 40.0789 30.5536 40.1601 30.2506L41.4013 25.6185C41.4825 25.3154 41.794 25.1355 42.0971 25.2168L55.2818 28.7496C55.5849 28.8309 55.7647 29.1424 55.6835 29.4454L54.4423 34.0776C54.3611 34.3805 54.0496 34.5604 53.7465 34.4792Z",
    fill: "#80B4FB"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M50.7727 45.743C49.5361 49.3071 45.6607 51.186 42.0966 49.9494C38.5324 48.7128 36.6536 44.8374 37.8902 41.2733C39.1268 37.7092 43.0021 35.8303 46.5663 37.0669C50.1304 38.3035 52.0093 42.1789 50.7727 45.743Z",
    fill: "#02C66A"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M50.7709 45.7435C49.5343 49.3076 45.6589 51.1865 42.0948 49.9499L46.5645 37.0674C50.1286 38.304 52.0075 42.1794 50.7709 45.7435Z",
    fill: "#00875A"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M47.302 43.4967L43.7302 45.2404L42.7662 45.7078L41.5092 43.0906L42.8589 42.4363L43.4714 43.6751L44.4354 43.2077L46.6477 42.1471L47.302 43.4967Z",
    fill: "#FFF5F5"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3088_4925"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 49.8462,
    height: 49.8462,
    fill: "white",
    transform: "translate(13.8457 11.0771)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLoanInputData);
export default __webpack_public_path__ + "static/media/loanInputData.12030a43f6816da353b97980abcb1077.svg";
export { ForwardRef as ReactComponent };